declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Record<string, string | number | boolean> }) => void;
  }
}

export function trackAffiliateClick(source: string) {
  if (typeof window !== 'undefined' && window.plausible) {
    window.plausible(`Affiliate Click: ${source}`, { props: { source } });
    window.plausible('Affiliate Click', { props: { source } });
  }
}
